<template>
  <div>
    <b-card
      title="Configuração White Label"
      tag="article"
      class="mb-12 border border-primary"
    >
      <div class="col-md-12">
        <b-row>
          <b-col md="4">
            <b-form-group label="Cor Primária" label-for="cor_primaria">
              <b-form-input type="color" v-model="form.cor_primaria" />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Cor Primária Hover" label-for="cor_primaria">
              <b-form-input type="color" v-model="form.cor_primaria_hover" />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Cor Secundária" label-for="cor_secundaria">
              <b-form-input type="color" v-model="form.cor_secundaria" />
            </b-form-group>
          </b-col>
        </b-row>
        <div class="brand-assets mt-4">
          <div class="mb-3">
            <h4 class="mb-1">Imagens da plataforma</h4>
            <p class="text-muted mb-0">
              Selecione uma imagem e ajuste o tamanho para visualizar como ela
              ficará na aplicação.
            </p>
          </div>

          <b-row>
            <b-col
              v-for="asset in brandAssets"
              :key="asset.field"
              cols="12"
              lg="6"
              class="mb-4"
            >
              <div class="brand-asset-card">
                <div class="brand-asset-card__header">
                  <div>
                    <strong>{{ asset.label }}</strong>
                    <small class="d-block text-muted">
                      {{ asset.location }}
                    </small>
                  </div>
                  <span v-if="asset.sizeField" class="brand-asset-card__size">
                    {{ getBrandAssetSize(asset) }} px
                  </span>
                </div>

                <b-form-file
                  accept=".jpg, .jpeg, .png"
                  :placeholder="`Selecione ${
                    asset.article
                  } ${asset.label.toLowerCase()}...`"
                  drop-placeholder="Solte a imagem aqui..."
                  @change="setBrandAsset($event, asset)"
                ></b-form-file>

                <div v-if="asset.sizeField" class="brand-size-control">
                  <label :for="`range-${asset.sizeField}`">
                    Tamanho da imagem
                  </label>
                  <div class="brand-size-control__inputs">
                    <b-form-input
                      :id="`range-${asset.sizeField}`"
                      v-model.number="form[asset.sizeField]"
                      type="range"
                      :min="asset.min"
                      :max="asset.max"
                      step="1"
                    />
                    <b-input-group
                      append="px"
                      class="brand-size-control__number"
                    >
                      <b-form-input
                        v-model.number="form[asset.sizeField]"
                        type="number"
                        :min="asset.min"
                        :max="asset.max"
                        @blur="normalizeBrandAssetSize(asset)"
                      />
                    </b-input-group>
                  </div>
                </div>

                <div
                  class="brand-preview"
                  :class="`brand-preview--${asset.preview}`"
                >
                  <div v-if="!asset.url" class="brand-preview__empty">
                    <i class="far fa-image"></i>
                    <span>Selecione uma imagem para visualizar</span>
                  </div>
                  <template v-if="asset.url">
                    <div
                      v-if="asset.preview === 'login'"
                      class="brand-preview__login"
                    >
                      <img
                        :src="asset.url"
                        :alt="`Pré-visualização da ${asset.label.toLowerCase()}`"
                        :style="brandAssetStyle(asset)"
                      />
                      <div class="brand-preview__login-title">
                        Acessar o sistema
                      </div>
                      <div class="brand-preview__login-field"></div>
                      <div class="brand-preview__login-field"></div>
                      <div class="brand-preview__login-button">Entrar</div>
                    </div>

                    <div
                      v-else-if="asset.preview === 'footer'"
                      class="brand-preview__digital-link"
                    >
                      <div class="brand-preview__digital-content">
                        <div class="brand-preview__document-icon">
                          <i class="far fa-file-alt"></i>
                        </div>
                        <span></span><span></span><span></span>
                      </div>
                      <div class="brand-preview__digital-footer">
                        <small>Rodapé do link digital</small>
                        <img
                          :src="asset.url"
                          :alt="`Pré-visualização da ${asset.label.toLowerCase()}`"
                          :style="brandAssetStyle(asset)"
                        />
                      </div>
                    </div>

                    <div
                      v-else-if="asset.preview === 'header'"
                      class="brand-preview__header"
                      :style="{
                        backgroundColor: form.cor_primaria || '#ee7361',
                      }"
                    >
                      <img
                        :src="asset.url"
                        :alt="`Pré-visualização da ${asset.label.toLowerCase()}`"
                        :style="brandAssetStyle(asset)"
                      />
                      <div class="brand-preview__header-navigation">
                        <span></span><span></span><span></span>
                      </div>
                      <div class="brand-preview__avatar"></div>
                    </div>

                    <div
                      v-else-if="asset.preview === 'compact'"
                      class="brand-preview__compact-menu"
                    >
                      <div class="brand-preview__compact-brand">
                        <img
                          :src="asset.url"
                          :alt="`Pré-visualização da ${asset.label.toLowerCase()}`"
                          :style="brandAssetStyle(asset)"
                        />
                      </div>
                      <span></span><span></span><span></span>
                    </div>

                    <div
                      v-else-if="asset.preview === 'browser'"
                      class="brand-preview__browser"
                    >
                      <div class="brand-preview__browser-controls">
                        <span></span><span></span><span></span>
                      </div>
                      <div class="brand-preview__browser-tab">
                        <img
                          :src="asset.url"
                          :alt="`Pré-visualização da ${asset.label.toLowerCase()}`"
                          :style="brandAssetStyle(asset)"
                        />
                        <span>{{ form.app_name || "Nome da plataforma" }}</span>
                      </div>
                    </div>
                  </template>
                  <span class="brand-preview__caption">
                    {{ asset.previewLabel }}
                  </span>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <br />
        <b-row>
          <b-col md="12">
            <b-form-group label="SubDomínio" label-for="host">
              <b-form-input type="text" v-model="form.host" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <h3 class="text-muted font-weight-bold d-block">
            Configuração E-mail:
          </h3>
        </b-row>
        <br />
        <b-row>
          <b-col md="6">
            <b-form-group label="E-mail Host" label-for="mail_host">
              <b-form-input type="text" v-model="form.mail_host" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="E-mail Porta" label-for="mail_port">
              <b-form-input type="text" v-model="form.mail_port" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Usuário" label-for="mail_username">
              <b-form-input type="text" v-model="form.mail_username" />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Senha" label-for="mail_password">
              <b-form-input type="password" v-model="form.mail_password" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Encryption" label-for="mail_encryption">
              <b-form-input type="text" v-model="form.mail_encryption" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Nome da plataforma" label-for="app_name">
              <b-form-input
                type="text"
                v-model="form.app_name"
                maxlength="10"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <br />
        <b-col class="col-lg-12" style="text-align: center">
          <button
            @click="gravarConfiguracao"
            class="btn btn-primary font-weight-bold"
          >
            Configurar
          </button>
          <router-link
            class="btn btn-clean font-weight-bold"
            :to="{
              name: 'clientesLista',
            }"
          >
            Voltar
          </router-link>
        </b-col>
      </div>
    </b-card>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import { mapGetters, mapActions } from "vuex";
import { mask } from "vue-the-mask";

export default {
  name: "app-configuracao-partner",
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      form: {
        tamanho_logo_principal: 180,
        tamanho_logo_secundaria: 180,
        tamanho_icone: 48,
        tamanho_icone_branco: 48,
      },
      totais: [],
      urlLogo: null,
      urlIcone: null,
      urlLogoSecundaria: null,
      urlIconeBranco: null,
      ulrFavIcon: null,
      objectUrls: {},
    };
  },
  directives: {
    mask,
  },
  computed: {
    ...mapGetters([
      "itsblocked",
      "idRevenda",
      "dadosRevenda",
      "isRevenda",
      "currentUser",
    ]),
    brandAssets() {
      return [
        {
          field: "logo_principal",
          sizeField: "tamanho_logo_principal",
          url: this.urlLogo,
          urlField: "urlLogo",
          label: "Logomarca principal",
          article: "a",
          location: "Telas de login, links e documentos",
          preview: "login",
          previewLabel: "Login / área pública",
          min: 40,
          max: 320,
          defaultSize: 180,
        },
        {
          field: "logo_secundaria",
          sizeField: "tamanho_logo_secundaria",
          url: this.urlLogoSecundaria,
          urlField: "urlLogoSecundaria",
          label: "Logomarca secundária",
          article: "a",
          location: "Rodapé de orçamentos, pedidos e outros links digitais",
          preview: "footer",
          previewLabel: "Rodapé dos links digitais",
          min: 40,
          max: 320,
          defaultSize: 180,
        },
        {
          field: "icone",
          sizeField: "tamanho_icone",
          url: this.urlIcone,
          urlField: "urlIcone",
          label: "Ícone",
          article: "o",
          location: "Menus compactos e atalhos",
          preview: "compact",
          previewLabel: "Área compacta",
          min: 16,
          max: 160,
          defaultSize: 48,
        },
        {
          field: "icone_branco",
          sizeField: "tamanho_icone_branco",
          url: this.urlIconeBranco,
          urlField: "urlIconeBranco",
          label: "Ícone branco",
          article: "o",
          location: "Cabeçalho do sistema (Header.vue)",
          preview: "header",
          previewLabel: "Cabeçalho do sistema",
          min: 16,
          max: 160,
          defaultSize: 48,
        },
        {
          field: "favicon",
          url: this.ulrFavIcon,
          urlField: "ulrFavIcon",
          label: "Favicon",
          article: "o",
          location: "Aba do navegador",
          preview: "browser",
          previewLabel: "Aba do navegador",
          min: 16,
          max: 64,
          defaultSize: 24,
        },
      ];
    },
  },
  async mounted() {
    if (!this.isRevenda) {
      this.$router.push({ name: "dashboard" });
    }
    await this.getDataInit();
  },
  beforeDestroy() {
    Object.keys(this.objectUrls).forEach((field) => {
      URL.revokeObjectURL(this.objectUrls[field]);
    });
  },

  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      this.setLoading(true);

      const data = await this.$http.post(
        "/empresa/cofing-partner",
        this.currentUser.usuario_empresa.empresa.nivel_revenda
      );
      if (data.data) {
        this.form = data.data;
        this.brandAssets.forEach((asset) => {
          if (asset.sizeField && !this.form[asset.sizeField]) {
            this.$set(this.form, asset.sizeField, asset.defaultSize);
          }
        });
        this.urlLogo = data.data.logo_principal;
        this.urlIcone = data.data.icone;
        this.urlIconeBranco = data.data.icone_branco;
        this.ulrFavIcon = data.data.favicon;
        this.urlLogoSecundaria = data.data.logo_secundaria;
      }
      this.setLoading(false);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    setBrandAsset(event, asset) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }

      if (this.objectUrls[asset.field]) {
        URL.revokeObjectURL(this.objectUrls[asset.field]);
      }

      const objectUrl = URL.createObjectURL(file);
      this.$set(this.objectUrls, asset.field, objectUrl);
      this.$set(this.form, asset.field, file);
      this[asset.urlField] = objectUrl;
    },
    getBrandAssetSize(asset) {
      if (!asset.sizeField) {
        return asset.defaultSize;
      }
      const size = Number(this.form[asset.sizeField]);
      if (!Number.isFinite(size)) {
        return asset.defaultSize;
      }
      return Math.min(asset.max, Math.max(asset.min, Math.round(size)));
    },
    normalizeBrandAssetSize(asset) {
      if (!asset.sizeField) {
        return;
      }
      this.$set(this.form, asset.sizeField, this.getBrandAssetSize(asset));
    },
    brandAssetStyle(asset) {
      const size = `${this.getBrandAssetSize(asset)}px`;
      return {
        width: size,
        maxWidth: asset.preview === "browser" ? size : "90%",
      };
    },
    async gravarConfiguracao() {
      this.setLoading(true);

      let configuracao = new FormData();

      if (
        this.form.logo_principal !== null &&
        this.form.logo_principal instanceof Blob
      ) {
        configuracao.append("logo_principal", this.form.logo_principal);
      }

      if (
        this.form.logo_secundaria !== null &&
        this.form.logo_secundaria instanceof Blob
      ) {
        configuracao.append("logo_secundaria", this.form.logo_secundaria);
      }

      if (
        this.form.icone_branco !== null &&
        this.form.icone_branco instanceof Blob
      ) {
        configuracao.append("icone_branco", this.form.icone_branco);
      }

      if (this.form.favicon !== null && this.form.favicon instanceof Blob) {
        configuracao.append("favicon", this.form.favicon);
      }

      if (this.form.icone !== null && this.form.icone instanceof Blob) {
        configuracao.append("icone", this.form.icone);
      }

      this.brandAssets
        .filter((asset) => asset.sizeField)
        .forEach((asset) => {
          this.normalizeBrandAssetSize(asset);
          configuracao.append(
            asset.sizeField,
            String(this.form[asset.sizeField])
          );
        });

      if (this.form.cor_primaria !== null) {
        configuracao.append("cor_primaria", this.form.cor_primaria);
      }

      if (this.form.cor_primaria_hover !== null) {
        configuracao.append("cor_primaria_hover", this.form.cor_primaria_hover);
      }

      if (this.form.cor_secundaria !== null) {
        configuracao.append("cor_secundaria", this.form.cor_secundaria);
      }

      if (this.form.host !== null) {
        configuracao.append("host", this.form.host);
      }

      if (this.form.mail_host !== null) {
        configuracao.append("mail_host", this.form.mail_host);
      }

      if (this.form.mail_port !== null) {
        configuracao.append("mail_port", this.form.mail_port);
      }

      if (this.form.mail_username !== null) {
        configuracao.append("mail_username", this.form.mail_username);
      }

      if (this.form.mail_password !== null) {
        configuracao.append("mail_password", this.form.mail_password);
      }

      if (this.form.mail_encryption !== null) {
        configuracao.append("mail_encryption", this.form.mail_encryption);
      }

      if (this.form.app_name !== null) {
        configuracao.append("app_name", this.form.app_name);
      }

      await this.$http
        .post("/empresa/create-configuracao-partner", configuracao)
        .then((result) => {
          if (result) {
            this.setLoading(false);
            this.$toast.success("Configuração atualizada com sucesso!");
          }
        });
      this.setLoading(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.brand-asset-card {
  height: 100%;
  padding: 1.25rem;
  border: 1px solid #e4e6ef;
  border-radius: 10px;
  background: #fff;
}

.brand-asset-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.brand-asset-card__size {
  flex-shrink: 0;
  padding: 0.25rem 0.6rem;
  border-radius: 999px;
  background: #f3f6f9;
  color: #3f4254;
  font-size: 0.8rem;
  font-weight: 600;
}

.brand-size-control {
  margin: 1rem 0;
}

.brand-size-control label {
  margin-bottom: 0.35rem;
  color: #3f4254;
  font-size: 0.85rem;
  font-weight: 600;
}

.brand-size-control__inputs {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.brand-size-control__number {
  width: 120px;
  flex-shrink: 0;
}

.brand-preview {
  position: relative;
  min-height: 280px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem 1rem 2.25rem;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  background: #fff;
}

.brand-preview img {
  display: block;
  height: auto;
  max-height: 160px;
  object-fit: contain;
  transition: width 0.15s ease;
}

.brand-preview__login {
  width: 280px;
  max-width: 92%;
  padding: 1.5rem;
  border: 1px solid #edf0f4;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 8px 28px rgba(24, 28, 50, 0.12);
  text-align: center;
}

.brand-preview__login img {
  margin: 0 auto 1rem;
}

.brand-preview__login-title {
  margin-bottom: 0.8rem;
  color: #181c32;
  font-size: 0.9rem;
  font-weight: 700;
}

.brand-preview__login-field {
  height: 24px;
  margin-bottom: 0.5rem;
  border: 1px solid #e4e6ef;
  border-radius: 5px;
  background: #f7f8fa;
}

.brand-preview__login-button {
  margin-top: 0.7rem;
  padding: 0.4rem;
  border-radius: 5px;
  background: var(--primary-color, #ee7361);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
}

.brand-preview__digital-link {
  width: 100%;
  min-height: 230px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 5px 16px rgba(24, 28, 50, 0.08);
}

.brand-preview__digital-content {
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 0.55rem;
  padding: 1.25rem;
  background: #f8f9fb;
}

.brand-preview__document-icon {
  margin-bottom: 0.35rem;
  color: #a1a5b7;
  font-size: 1.7rem;
}

.brand-preview__document-icon i {
  color: inherit;
  font-size: inherit;
}

.brand-preview__digital-content > span {
  width: 65%;
  height: 7px;
  border-radius: 4px;
  background: #dfe3e9;
}

.brand-preview__digital-content > span:nth-of-type(2) {
  width: 48%;
}

.brand-preview__digital-content > span:nth-of-type(3) {
  width: 56%;
}

.brand-preview__digital-footer {
  min-height: 82px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-top: 1px solid #edf0f4;
  background: #fff;
}

.brand-preview__digital-footer small {
  color: #a1a5b7;
  font-size: 0.65rem;
}

.brand-preview__digital-footer img {
  max-height: 64px;
}

.brand-preview__header {
  width: 100%;
  min-height: 88px;
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 1rem;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  box-shadow: 0 5px 16px rgba(24, 28, 50, 0.08);
}

.brand-preview__header img {
  max-height: 64px;
}

.brand-preview__header-navigation {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}

.brand-preview__header-navigation span {
  width: 46px;
  height: 8px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.62);
}

.brand-preview__avatar {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.78);
}

.brand-preview__compact-menu {
  width: 104px;
  min-height: 220px;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 0.7rem;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 5px 16px rgba(24, 28, 50, 0.08);
}

.brand-preview__compact-brand {
  min-height: 76px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid #edf0f4;
}

.brand-preview__compact-menu > span {
  width: 34px;
  height: 8px;
  border-radius: 4px;
  background: #d9dde4;
}

.brand-preview__browser {
  position: relative;
  width: 100%;
  min-height: 150px;
  padding: 42px 1rem 1rem;
  border: 1px solid #d9dde4;
  border-radius: 8px;
  background: #fff;
}

.brand-preview__browser-controls {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 30px;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 10px;
  background: #e9edf2;
}

.brand-preview__browser-controls span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #aeb7c2;
}

.brand-preview__browser-tab {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  width: 210px;
  max-width: 100%;
  padding: 0.55rem 0.7rem;
  border: 1px solid #e4e6ef;
  border-radius: 6px;
  color: #5e6278;
  font-size: 0.75rem;
}

.brand-preview__browser-tab img {
  flex-shrink: 0;
}

.brand-preview__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: #7e8299;
  text-align: center;
}

.brand-preview__empty i {
  font-size: 2rem;
}

.brand-preview__caption {
  position: absolute;
  right: 0.75rem;
  bottom: 0.55rem;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.52);
  color: #fff;
  font-size: 0.7rem;
}

@media (max-width: 575.98px) {
  .brand-size-control__inputs {
    align-items: stretch;
    flex-direction: column;
  }

  .brand-size-control__number {
    width: 100%;
  }
}
</style>

<style lang="scss">
.vs__dropdown-toggle {
  border: 2px solid #dedede;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 6px;
  outline: none;
  height: 500px;
}
@import "../../../assets/styles/styleCardPayment.scss";
</style>
